import { Loader2 } from 'lucide-react';

export function LoadingLabel() {
  return (
    <span className="inline-flex items-center gap-2 text-gray-500">
      <Loader2 className="size-4 animate-spin" />
      Chargement…
    </span>
  );
}
